const etamessaging = {
    formatEta: function(jsDate) {
        return this._getDayNameAbbr(jsDate) + ' ' + (jsDate.getMonth() + 1) + '/' + jsDate.getDate();
    },
    _getDayNameAbbr: function(jsDate) {
        return ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'][jsDate.getDay()];
    }
};

export default etamessaging;
